import {
  IInfoServiceMock
} from './index'

export const mockInfoService = (): IInfoServiceMock => ({
  getAllPartners: jest.fn(),
  getPartnerById: jest.fn(),

  getAllContactWays: jest.fn(),
  getContactWayById: jest.fn(),

  getAllFaqItems: jest.fn(),
  getFaqItemById: jest.fn(),

  getAllNews: jest.fn(),
  getNewsById: jest.fn(),

  getAllBeautyPlaces: jest.fn(),
  getBeautyPlaceById: jest.fn()
})
